// Cache and Session Timeout Constants
export const CACHE_CONSTANTS = {
    // 24 hours in milliseconds
    SESSION_TIMEOUT: 24 * 60 * 60 * 1000,
    // How often the widget checks the official store lists for changes (24 hours)
    STORE_LOCATIONS_SYNC_INTERVAL: 24 * 60 * 60 * 1000,
    // How long the background store list check waits for a response (10 seconds)
    STORE_LOCATIONS_SYNC_TIMEOUT: 10 * 1000,
    // Cache keys
    CACHE_KEYS: {
        EZQUOTE_STATE: 'ezquote_state',
        INTRO_MODAL_SHOWN: 'introModalShown',
        USER_EMAIL_COLLECT: 'ezquote_user_email',
        USER_EMAIL: 'ezquote_user_phone',
        USER_ZIPCODE: 'ezquote_user_zipcode',
        USER_NAME: 'ezquote_user_name',
        STORE_INFO: 'ezquote_store_info',
        ACCESS_TOKEN: 'ezq.user.token',
        CACHE_TIMESTAMP: 'ezquote_cache_timestamp',
        STORE_LOCATIONS: 'ezquote_store_locations'
    },
    // Keys that should be preserved during cache clear
    PRESERVED_KEYS: [
        'introModalShown',
        'ezquote_user_email',
        'ezquote_user_phone',
        'ezquote_user_zipcode',
        'ezquote_user_name',
        // Store list synced from the official store lists — never cleared, so
        // stores a customer has already seen don't disappear (LW-1550).
        'ezquote_store_locations'
    ]
};
